export default __webpack_public_path__ + "static/media/melao_amarelo.193d6121.jpg";